<div class="container">
  <main role="main" class="w-100 m-auto text-center">
    <h1>Clever Login</h1>
    <div><app-loader></app-loader></div>
  </main>
</div>
